import { Button } from "../ui/button";
import blueshield from "@/assets/blueshield.svg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import arrowLottie from "@/assets/lottie/arrow.lottie?url";


export function DialogBottomButtonContent({
  onNextGameClick,
  onGoHomeClick,
  middleText,
}: {
  onNextGameClick(): void;
  onGoHomeClick(): void;
  isTutorial: boolean;
  middleText: string;
}) {

  return (
    <div className="mb-0 flex flex-col justify-between">
      <div className='justify-center flex flex-col items-center'>
          <Button 
            className="py-7 bg-blue text-white text-3xl font-extrabold rounded-lg mb-4 px-8 flex items-center justify-center gap-2"
            shine
            size='lg'
            onClick={() => onNextGameClick()}
          >
            SCRATCH NEXT
            <span className='h-5 w-5 items-center justify-center'>
              <DotLottieReact
                src={arrowLottie}
                autoplay
                loop
                style={{
                  objectFit: "contain",
                  transform: "translateY(0px)"
                }}
              />
            </span>
          </Button>
      </div>

      <div className="flex flex-row items-center justify-center mb-6">
        <img src={blueshield} className='h-4 mr-1 text-blue' alt='secure'/>
        <p className=' text-md font-bold text-blue text-center'>{middleText}</p>
      </div>

      <Button 
        className="bg-gray-50 text-gray-300 text-xl font-bold w-1/2 rounded-lg shadow-none mx-auto mb-0 w-2/3"
        size='lg'
        onClick={() => onGoHomeClick()}
        // bounceEffect="none"
      >
          or go back home
      </Button>
    </div>
  );
}